import React, { useCallback, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ReactToPrint from "react-to-print";
import image1 from "../../Gdigital _Eaglelogo.png";
import { AiOutlineClose } from "react-icons/ai";
import Cookies from "js-cookie";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { AWS_URL } from "../../../Constant";

// NEW: import jsPDF
import { jsPDF } from "jspdf";

const Invoice = ({
  info,
  invoiceBillGenrate,
  setInvoiceBillGenrate,
  customerForm,
  date,
  submittedData,
  datas,
  totalCalGst,
  netPrice,
  total,
  paymentMode,
  transactionId,
  totalAmtWithoutGst,
  gst,
  subtotal,
}) => {
  const componentRef = useRef();
  const sentOnceRef = useRef(false);

  const getFinancialYear = (billDate) => {
    const parsedDate = billDate instanceof Date ? billDate : new Date(billDate);
    const referenceDate = !Number.isNaN(parsedDate?.getTime()) ? parsedDate : new Date();
    const year = referenceDate.getFullYear();
    const startYear = referenceDate.getMonth() >= 3 ? year : year - 1;
    const endYear = startYear + 1;
    return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
  };

  const financialYear = getFinancialYear(date);

  const saveAsImage = () => {
    html2canvas(componentRef.current).then((canvas) => {
      canvas.toBlob((blob) => {
        saveAs(blob, customerForm.customerName);
      });
    });
  };

  const showTime =
    date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

  const generateAndUploadPDF = useCallback(async () => {
    try {
      // Render the DOM node to canvas
      const canvas = await html2canvas(componentRef.current, {
        scale: 2, // increasing scale improves PDF clarity
        useCORS: true,
        allowTaint: true,
      });

      // Convert canvas to image data URL
      const imgData = canvas.toDataURL("image/png");
      

      // Calculate PDF size in mm from pixels (1 px = 0.264583 mm)
      const pxToMm = (px) => px * 0.264583;
      const imgWidthMm = pxToMm(canvas.width);
      const imgHeightMm = pxToMm(canvas.height);

      // Create a jsPDF instance with exact size so there is no scaling distortion
      const pdf = new jsPDF({
        unit: "mm",
        format: [imgWidthMm, imgHeightMm],
        orientation: imgWidthMm >= imgHeightMm ? "landscape" : "portrait",
      });

      // Add image to PDF at full size (0,0) - fills the page
      pdf.addImage(
        imgData,
        "PNG",
        0,
        0,
        imgWidthMm,
        imgHeightMm,
        undefined,
        "FAST"
      );

      // Export PDF as blob
      const pdfBlob = pdf.output("blob");

      // Debug logs (optional)
// Prepare form data and upload
      const formData = new FormData();
      // Use invoice.pdf as the filename and proper PDF blob
      formData.append("pdf", pdfBlob, "invoice.pdf");
      formData.append("customerName", customerForm.customerName);
      formData.append("customerNumber", customerForm.customerNumber);
      formData.append("billNo", submittedData["Bill No"]);

      const jwtToken = Cookies.get("jwt_token");
      const url = `${AWS_URL}/pdfupload`;
      const options = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
        body: formData,
      };

      const response = await fetch(url, options);
      if (response.ok) {
        await response.json();
} else {
        await response.text();
}
    } catch (error) {
}
  }, [componentRef, customerForm, submittedData]);

  

  useEffect(() => {
    if (
      invoiceBillGenrate &&
      customerForm?.customerName &&
      submittedData?.["Bill No"] &&
      componentRef.current &&
      !sentOnceRef.current
    ) {
      sentOnceRef.current = true;
      generateAndUploadPDF().catch((e) => {});
    }

    // reset guard when invoiceBillGenrate becomes false so next open can send again
    if (!invoiceBillGenrate) {
      sentOnceRef.current = false;
    }
  }, [invoiceBillGenrate, customerForm, submittedData, generateAndUploadPDF]);

  return (
    <>
      <div className=" md:w-[3in] sm:w-[3in] lg:w-[3in] xs:w-[3in] w-full h-full text-xs">
        <div className=" w-full h-full flex items-center justify-center ">
          {invoiceBillGenrate && (
            <div className=" p-2 absolute top-0 md:top-[-50px] left-0 bg-[#e6e5e48a] w-full h-full flex items-center justify-center">
              <div className="w-full md:w-[3in] xs:w-[3in] sm:w-[3in] bg-white p-2 text-black ">
                <div className="text-right">
                  <button onClick={() => setInvoiceBillGenrate(false)}>
                    <Link to={"/dashboard"}>
                      <AiOutlineClose />
                    </Link>
                  </button>
                </div>

                <div
                  className="md:w-[3.1in] lg:w-[3.1in] xs:w-[3in] p-1"
                  ref={componentRef}
                >
                  <div className="flex  items-center justify-center ">
                    <img className="w-10 rounded-lg " src={image1} alt="" />
                  </div>
                  <h1 className="font-gdigital text-[10px] font-semibold tracking-tight text-red-600">
  G-DIGITAL
</h1>
{/* <h1 className="
  font-gdigital
  text-6xl
  tracking-[0.2em]
  text-white
  drop-shadow-[0_4px_6px_rgba(0,0,0,0.6)]
">
  G-DIGITAL
</h1> */}

                  <div>
                    <h4 className=" font-medium text-center text-[10px]">
                      Invoice Bill
                    </h4>
                  </div>

                  <div className="flex flex-col text-xs sm:w-auto ">
                    <h4 className="font-bold text-center text-[7px]">
                      {/* G-Digital, */}
                       {info.Name}
                    </h4>
                    <p className="text-[8px] w-[2.8in] font-medium text-center">
                      {info.Address}
                    </p>
                    <p className="text-[8px] font-medium text-center">
                      Contact : {info.Contact}
                    </p>
                    <p className="text-[8px] font-medium text-center">
                      GST : {info.GST}
                    </p>
                  </div>
                  <div className="flex justify-between">
                    <div className=" flex flex-col text-start  ">
                      <h1 className="font-medium text-[10px]">
                        Customer Information data found here
                      </h1>
                      <div className="flex justify-center">
                        <div className="w-[210px]">
                          <p className="text-left font-medium flex items-center text-[8px]">
                            <span className=" font-medium text-[8px] mr-1 w-[30px]">
                              Name :
                            </span>
                            {customerForm.customerName}
                          </p>
                          <p className="text-left font-medium flex items-center text-[8px]">
                            <span className=" font-medium text-[8px] mr-1 w-[35px]">
                              Contact :
                            </span>
                            {customerForm.customerNumber}
                          </p>
                          <p className="text-left font-medium flex text-[8px]">
                            <span className="font-medium text-[8px] mr-1 w-[40px]">
                              Address :
                            </span>
                            <div className="w-[140px]">
                              {customerForm.customerAddress}
                            </div>
                          </p>
                        </div>
                        <div className="sm:text-xs w-[100px] font-medium pr-7 -ml-7 text-left">
                          <p className="   text-[8px] ">
                            Date : {date.toLocaleDateString()} <br />
                            Time: {showTime}
                          </p>
                          <h1 className=" font-medium  text-[7px]">
                            Bill No : GD/{financialYear}/{submittedData["Bill No"]}
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="mt-2 ">
                      <div className="pr-5 ">
                        <div className=" md:rounded-sm ">
                          <table
                            className="w-[3in] text-xs border-collapse border border-black "
                            style={{ width: "100%", tableLayout: "fixed" }}
                          >
                            <thead className="bg-white w-[3in] ">
                              <tr>
                                <th
                                  className="text-center max-w-[6px] text-[8px] text-black border border-black  "
                                  id="product"
                                  style={{ width: "30%" }}
                                >
                                  Name
                                </th>
                                <th
                                  className="text-[7px] text-center   text-black  border border-black"
                                  style={{
                                    width: "13%",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  S.No
                                </th>
                                <th
                                  className="text-[7px]   text-black  border border-black"
                                  style={{ width: "8%" }}
                                >
                                  Qty
                                </th>

                                <th
                                  className="text-[7px] text-center   text-black border border-black "
                                  style={{ width: "12%" }}
                                >
                                  MRP
                                </th>

                                <th
                                  className="text-[7px]    text-black  border border-black"
                                  style={{ width: "13%" }}
                                >
                                  Discount
                                </th>
                                <th
                                  className="text-[7px] text-center   text-black  border border-black"
                                  style={{ width: "8%" }}
                                >
                                  GST
                                </th>
                                <th
                                  className="text-[7px] text-center   text-black  border border-black"
                                  style={{ width: "12%" }}
                                >
                                  Price
                                </th>

                                <th
                                  className="text-[7px]  text-black border border-black "
                                  style={{ width: "13%" }}
                                >
                                  Total
                                </th>
                              </tr>
                            </thead>
                            <tbody className=" bg-white text-black border-red-600">
                              {datas.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td
                                      id="product"
                                      className="text-[7px] text-left text-black border border-black p-[3px] "
                                    >
                                      <span className="font-bold ">
                                        {item.productName}
                                      </span>
                                      <div className="border-t border-gray-800  my-[2px]"></div>

                                      <div className="text-[7px] text-black">
                                        <span className="font-bold">
                                          Model No:
                                        </span>{" "}
                                        <span className="font-medium">
                                          {" "}
                                          {item.model_number || "-"}{" "}
                                        </span>
                                      </div>
                                    </td>
                                    <td
                                      className="text-[7px] text-center font-bold text-black  border border-black"
                                      style={{
                                        width: "5%",
                                        wordWrap: "break-word",
                                      }}
                                    >
                                      {item.serialNumber}
                                    </td>
                                    <td className="text-[9px] text-center  font-bold text-black border border-black">
                                      {item.quantity}
                                    </td>
                                    <td className="text-[9px] text-center font-bold text-black border border-black">
                                      {item.mrp1}
                                    </td>
                                    <td className="text-[9px] text-center font-bold text-black border border-black">
                                      {item.discount}
                                    </td>

                                    <td className="text-[9px] text-center font-bold text-black  border border-black">
                                      {item.gst}
                                    </td>
                                    <td className="text-[9px] text-center font-bold text-black border border-black">
                                      {parseInt(netPrice[index])}
                                    </td>

                                    <td className="text-[9px] text-center font-bold text-black border border-black">
                                      {total[index]}
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-start items-start mt-2">
                      <p>
                        <span className="text-left text-[10px] font-bold">
                          Payment Mode : {paymentMode}
                        </span>
                        <div className="flex flex-col text-[10px] ">
                          <p className="">{transactionId}</p>
                        </div>
                      </p>
                    </div>
                    <div>
                      <div
                        className="flex flex-col text-[5px] items-end justify-end border-lg p-2 mr-3 space-x-3"
                        style={{ textAlign: "right" }}
                      >
                        <div className="text-[10px] font-bold">
                          Subtotal : Rs{" "}
                          {parseFloat(totalAmtWithoutGst).toFixed(2)}
                        </div>

                        <div className=" text-[10px] font-bold">
                          GST : Rs {parseFloat(gst).toFixed(2)}
                        </div>
                        <div className="text-[10px] font-bold">
                          Total : Rs {parseFloat(subtotal).toFixed(2)}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 text-center text-[8px] font-medium">
                    Thank you for shopping with us! <br />
                    <span className="text-gray-600">Visit again</span>
                  </div>
                </div>
                <ReactToPrint
                  pageStyle="@media print {
                      @page {
                       size: 3in ;
                       margin: 1;
                       font-size: 1pt
                    }
                      }"
                  trigger={() => (
                    <button className="bg-blue-500 text-sm p-1 rounded-lg w-24 text-center">
                      Print
                    </button>
                  )}
                  // content={() => componentRef.current}
                  content={() => componentRef.current}
                  onBeforeGetContent={() => {
                    //generateAndUploadPDF();
                  }}
                />
                <button
                  className="bg-blue-500 ml-3 text-sm p-1 rounded-lg w-24 text-center"
                  onClick={saveAsImage}
                >
                  Save as PNG
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Invoice;
